<ng-template #notesContainer></ng-template>
